function TheFork({ restaurantName, address }) {
  const searchQuery = `${restaurantName} ${address}`
  const tripadvisorSearchUrl = `https://www.tripadvisor.com/Search?q=${encodeURIComponent(searchQuery)}`
  return (<>
    <a href={tripadvisorSearchUrl} target="_blank" rel="noopener noreferrer" className="book-btn-thefork" style={{
      backgroundColor: '#008a4b', // Verde TheFork
      color: '#ffffff',
      padding: '7px 15px',
      borderRadius: '8px',
      textDecoration: 'none',
      fontWeight: 'bold',
      display: 'inline-block'
    }}>
      🔍 Verifica disponibilità
    </a>
  </>
  )
}
export default TheFork
